import { render, staticRenderFns } from "./org_manage.vue?vue&type=template&id=efb69f88&scoped=true"
import script from "./org_manage.vue?vue&type=script&lang=js"
export * from "./org_manage.vue?vue&type=script&lang=js"
import style0 from "./org_manage.vue?vue&type=style&index=0&id=efb69f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb69f88",
  null
  
)

export default component.exports